// Global Video Play/Pause Toggle
  (function () {
    function initVideoToggles() {
      document.querySelectorAll('.video-wrapper').forEach(function (wrapper) {
        const video = wrapper.querySelector('video');
        const toggle = wrapper.querySelector('.play-pause-toggle');
        if (!video || !toggle) return;

        toggle.classList.toggle('is-playing', !video.paused);

        toggle.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            toggle.classList.add('is-playing');
          } else {
            video.pause();
            toggle.classList.remove('is-playing');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoToggles);
    } else {
      initVideoToggles();
    }
  })();

// Global Dropdown Handler
  (function () {
    function initDropdowns() {
      document.querySelectorAll('.dropdown-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          const parent = this.closest('.dropdown-single');
          const isAlreadyOpen = parent.classList.contains('is-open');

          // Close all open dropdowns
          document.querySelectorAll('.dropdown-single.is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
          });

          if (!isAlreadyOpen) {
            parent.classList.add('is-open');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDropdowns);
    } else {
      initDropdowns();
    }
  })();
  
// Care Guide Modal
function closeCareGuide() {
  var overlay = document.getElementById('care-guide-overlay');
  if (!overlay) return;
  overlay.classList.remove('is-open');
  document.getElementById('care-guide-image').src = '';
  document.body.style.overflow = '';
}

document.addEventListener('click', function(e) {
  const careTrigger = e.target.closest('.product-card-image-toggle');
  if (careTrigger) {
    document.getElementById('care-guide-image').src = careTrigger.dataset.url;
    document.getElementById('care-guide-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    return;
  }

  if (e.target.closest('#care-guide-close') || e.target.id === 'care-guide-overlay') {
    closeCareGuide();
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeCareGuide();
});

// Combined Product Size & Washing Instructions Toggler
function closeAllModals() {
  document.getElementById('size-guide-overlay').classList.remove('is-open');
  document.getElementById('size-guide-image').src = '';
  document.getElementById('care-guide-overlay').classList.remove('is-open');
  document.getElementById('care-guide-image').src = '';
  document.body.style.overflow = '';
}

document.addEventListener('click', function(e) {
  const sizeGuide = e.target.closest('.size-guide');
  if (sizeGuide) {
    document.getElementById('size-guide-image').src = sizeGuide.dataset.sizeGuideImage;
    document.getElementById('size-guide-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  const careTrigger = e.target.closest('.product-card-image-toggle');
  if (careTrigger) {
    document.getElementById('care-guide-image').src = careTrigger.dataset.url;
    document.getElementById('care-guide-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  if (e.target.closest('#size-guide-close') || e.target.id === 'size-guide-overlay' ||
      e.target.closest('#care-guide-close') || e.target.id === 'care-guide-overlay') {
    closeAllModals();
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeAllModals();
});

// Swiper - Collection Cards
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ms-collection-slider .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 2.45,
        spaceBetween: 10,
        scrollbar: {
          el: el.querySelector('.ms-collection-slider.swiper-scrollbar'),
          draggable: true,
        },
        breakpoints: {
          1200: { slidesPerView: 6 },
          1000: { slidesPerView: 4.5 },
          800: { slidesPerView: 3.75 },
          700:  { slidesPerView: 3.25 },
          550:  { slidesPerView: 2.75 },
        },
      });
    });
  });